import { arrayOf, func } from 'prop-types';
import React from 'react';
import Select from 'react-select';

import { getRelatedCIProduct, isCIDash, isCISetup } from '../../products/utils';
import { opportunityShape, productShape, quoteShape } from '../../prop-types';
import { flash } from '../../utils/flash';
import initializeQuoteLineFrom from '../utils/initialize-quote-line';
import getIndex from './get-index';

function getSpecificCompanion(code, existing, companion, products) {
  const companionCode = code.replace(existing, companion);
  if (code === companionCode) {
    return null;
  }
  return products.find(candidate => candidate.code === companionCode);
}

function flashMissingCompanionWarning(newProduct, products, selectedProducts) {
  const companionProduct =
    getSpecificCompanion(newProduct.code, '_WEB_', '_APP_', products) ||
    getSpecificCompanion(newProduct.code, '_APP_', '_WEB_', products);

  if (companionProduct && !selectedProducts.includes(companionProduct)) {
    const label = `${companionProduct.name} (${companionProduct.business}, ${companionProduct.productGroup})`;
    flash(
      `Please note that this product covers only one of APP and WEB (Desktop/Mobile). If you want to have this Ad Format set up in both, please add another quote line with ${label}`,
      'warning',
      10,
    );
  }
}

class ProductSelection extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(selectedOption) {
    const { onAddQuoteLine, quote, quoteLineProducts, products, opportunity } =
      this.props;
    const { product } = selectedOption;
    const lineNumber = getIndex(product, quoteLineProducts);
    const newQuoteLine = initializeQuoteLineFrom(
      quote,
      product,
      opportunity,
      lineNumber,
    );

    flashMissingCompanionWarning(product, products, quoteLineProducts);

    onAddQuoteLine(newQuoteLine);

    this.addAdditionalLinesForSiblings(product, lineNumber);
  }

  addAdditionalLinesForSiblings(product, lineNumber) {
    const { onAddQuoteLine, quote, products, opportunity } = this.props;

    if (isCIDash(product) || isCISetup(product)) {
      const relatedProduct = getRelatedCIProduct(product, products);
      const newLineNumber = lineNumber + 1;
      const additionalQuoteLine = initializeQuoteLineFrom(
        quote,
        relatedProduct,
        opportunity,
        newLineNumber,
      );
      onAddQuoteLine(additionalQuoteLine);
    }
  }

  render() {
    const { products } = this.props;

    const options = products.map(product => ({
      label: `${product.name} - ${product.business}, ${product.productGroup}`,
      value: product.code,
      product,
    }));

    return (
      <Select
        options={options}
        value=""
        placeholder="Add product…"
        onChange={this.handleSelect}
        menuPortalTarget={document.body}
        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
      />
    );
  }
}

ProductSelection.propTypes = {
  products: arrayOf(productShape).isRequired,
  quote: quoteShape.isRequired,
  opportunity: opportunityShape.isRequired,
  onAddQuoteLine: func.isRequired,
  quoteLineProducts: arrayOf(productShape).isRequired,
};

export default ProductSelection;
